/* eslint-disable jira/filename-case */
import pickBy from 'lodash/pickBy';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import { UI_EVENT_TYPE } from './events.tsx';
import mapAnalyticsDataPayloadToContext from './map-data-payload-to-context-payload.tsx';
import type { FireUiAnalyticsPayload } from './types.tsx';

// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const isNotUndefined = (a) => a !== undefined;

const mapPayload = (payload: FireUiAnalyticsPayload) => {
	const context = mapAnalyticsDataPayloadToContext(payload);
	const { name } = payload;
	return pickBy(
		{
			...context,
			...context.attributes,
			attributes: undefined,
			name,
		},
		isNotUndefined,
	);
};

export const fireUiAnalytics = (event: UIAnalyticsEvent, payload: FireUiAnalyticsPayload): void => {
	event.update({ ...mapPayload(payload), analyticsType: UI_EVENT_TYPE }).fire();
};
